import SurveyAnalysis from '@components/dynamic-survey/details/SurveyAnalysis';
import { AnalysisSVG } from '@components/icon/svg';
import { useCheckCredits } from '@hooks/useCheckCredits';
import { Box, Card, Typography } from '@mui/material';
import { useState } from 'react';

export default function NoAnalysis({ studyId, isInterview, px }) {
  const { NoCreditDialog } = useCheckCredits();
  const [openDialog, setOpenDialog] = useState(false);

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <Box py={3} px={px === 0 ? 0 : px || 5} sx={{ height: 'calc(100vh - 120px)' }}>
      <Card
        variant="outlined"
        sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            textAlign: 'center',
          }}
        >
          <AnalysisSVG />
          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <Typography mb={1} variant="h6">
              Analysis hasn’t been run yet
            </Typography>
            <Typography variant="body2">
              Please run analysis to view all responses insights.{' '}
            </Typography>
          </Box>
        </Box>
      </Card>
      <NoCreditDialog />
      <SurveyAnalysis
        openDialog={openDialog}
        handleCloseDialog={handleCloseDialog}
        rowId={studyId}
        isInterview={isInterview}
      />
    </Box>
  );
}
